module.exports = __webpack_public_path__ + "media/images/category/travel-tips-138917ec5a918448fff1765753e51100.svg";